export default __webpack_public_path__ + "static/media/delete_icon.6e2d17a4.svg";